import { render, staticRenderFns } from "./ContractInfo.vue?vue&type=template&id=0d276fae&scoped=true&"
import script from "./ContractInfo.vue?vue&type=script&lang=js&"
export * from "./ContractInfo.vue?vue&type=script&lang=js&"
import style0 from "./ContractInfo.vue?vue&type=style&index=0&id=0d276fae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d276fae",
  null
  
)

export default component.exports